import React, { useState, useEffect, useRef } from 'react';
import { render } from 'react-dom';

import Auth from '~c/popups/Auth';
import { siteRegInputs, siteRegInputsCompany } from './siteRegInputs';
import { prepareInput } from '../Input';
// import { setLocalAuthParam } from '../analytics';

import { getCity } from '../utils';
import { formatPhoneToNumber } from '~h/format-phone';

import { parseCompanyDadata, registerCompanyRequest } from '../utils';

import PassRestorationReset from '~c/popups/PassRestorationReset';
import SmsVerification from '~c/popups/SmsVerification';
import { Button } from '~c/ui/Button';
import { ButtonTabs } from '~c/ui/ButtonTabs';
import CheckPolicy from '../CheckPolicy';
import { CheckSubscribe } from '../CheckSubscribe';
import { FormMessage } from '~c/FormMessage';
import openErrorMsgForm from '~c/popups/ErrorSender';

import messages from '~h/messages';
import routes from '~/apiRouter';
import metrikaGoal from '../../../helpers/metrikaGoal';

export const SiteReg = props => {
  // const defaultformData = {
  //   name: '',
  //   lastName: '',
  //   patronymic: '',
  //   phone: '',
  //   email: '',
  //   company: '',
  //   companyPosition: '',
  // };

  // const [formData, setFormData] = useState(defaultformData);
  // const [inputs, setInputs] = useState(siteRegInputs);
  // const [subscribe, setSubscribe] = useState(true);
  // const [isPending, setIsPending] = useState(false);
  // const [errorMessages, setErrorMessages] = useState([]);
  // const [isCompanyReg, setIsCompanyReg] = useState(props.isCompanyReg);
  // const [selectedCompany, setSelectedCompany] = useState({});

  // const [dadataValueExists, setDadataValueExists] = useState(false);

  // useEffect(() => {
  //   setErrorMessages([]);
  //   if (isCompanyReg) {
  //     metrikaGoal('regAsComp');
  //     setInputs([...siteRegInputs, ...siteRegInputsCompany]);
  //   } else {
  //     metrikaGoal('regAsPers');
  //     setInputs(siteRegInputs);
  //   }
  // }, [isCompanyReg]);

  // const checkPolicyRef = useRef(null);

  // const loginViaPopup = () => {
  //   $.magnificPopup.open({
  //     removalDelay: 250,
  //     closeOnBgClick: false,
  //     mainClass: 'mfp-anim',
  //     items: {
  //       src: $('#popup'),
  //       type: 'inline',
  //     },
  //     callbacks: {
  //       open: () => {
  //         document.body.style.overflow = 'hidden';
  //         render(
  //           <Auth
  //             onAuthCallback={() => {
  //               // setLocalAuthParam('Авторизовался в процессе');
  //               if(props.onAuth){
  //                 props.onAuth();
  //               }
  //               $.magnificPopup.close();
  //             }}
  //             onAuthLocation=""
  //             onRegCompliteLocation=""
  //           />,
  //           $('#popup')[0],
  //         );
  //       },
  //       close() {
  //         document.body.style.overflow = '';
  //         render(<div />, $('#popup')[0]);
  //       },
  //     },
  //   });
  // };

  // const createNewPassword = async () => {
  //   let doneResolver;
  //   const creationDone = new Promise(resolve => {
  //     doneResolver = resolve;
  //   });

  //   $.magnificPopup.open({
  //     removalDelay: 250,
  //     mainClass: 'mfp-anim',
  //     closeOnBgClick: false,
  //     items: {
  //       src: $('#popup'),
  //       type: 'inline',
  //     },
  //     callbacks: {
  //       open: () => {
  //         render(
  //           <PassRestorationReset
  //             header="Придумайте пароль"
  //             buttonCaption="Далее"
  //             onRegCompliteCallback={() => {
  //               if(props.onAuth){
  //                 props.onAuth();
  //               }
  //               $.magnificPopup.close();
  //               doneResolver();
  //             }}
  //             onRegCompliteLocation=""
  //           />,
  //           $('#popup')[0],
  //         );
  //       },
  //       close() {
  //         render(<div />, $('#popup')[0]);
  //       },
  //     },
  //   });

  //   await creationDone;
  // };

  // const verifyViaSms = async phone => {
  //   let doneResolver;
  //   const verificationDone = new Promise(resolve => {
  //     doneResolver = resolve;
  //   });
  //   $.magnificPopup.open({
  //     removalDelay: 250,
  //     mainClass: 'mfp-anim',
  //     items: {
  //       src: $('#popup'),
  //       type: 'inline',
  //     },
  //     closeOnBgClick: false,
  //     callbacks: {
  //       open: () => {
  //         render(
  //           <SmsVerification
  //             phone={`${formatPhoneToNumber(phone)}`}
  //             user={formData}
  //             onVerifyLocation=""
  //             isPolicyAgreed={checkPolicyRef.current?.validateCheck()}
  //             isNewsSubscribe={subscribe}
  //             onVerifyCallback={() => {
  //               $.magnificPopup.close();

  //               // this.params.analyticParams.auth = 'Новый пользователь';

  //               setTimeout(() => {
  //                 doneResolver();
  //               }, 500);
  //             }}
  //           />,
  //           $('#popup')[0],
  //         );
  //       },
  //       close() {
  //         render(<div />, $('#popup')[0]);
  //       },
  //     },
  //   });

  //   await verificationDone;
  // };

  // const registerNewUser = async () => {
  //   const { type = isCompanyReg ? 'company' : 'person'} = props;

  //   setErrorMessages([]);
  //   setIsPending(true);

  //   const city = getCity();

  //   const userCompanyData = {
  //     JOB_TITLE: formData.companyPosition || undefined,
  //     COMPANY_NAME: formData.company || undefined,
  //   };

  //   const userGeneralData = {
  //     LOGIN: formatPhoneToNumber(formData.phone),
  //     TELEPHONE: formatPhoneToNumber(formData.phone),
  //     EMAIL: formData.email || undefined,
  //     NAME: formData.name || undefined,
  //     LAST_NAME: formData.lastName || undefined,
  //     SECOND_NAME: formData.patronymic || undefined,
  //     CITY: city.cityName || undefined,
  //     CITY_CODE: city.cityCode || undefined,
  //     TYPE: type,

  //     BIRTH_DATE: formData?.birthday || undefined,
  //     MKT_SUBSCRIPTION: subscribe || undefined,
  //   };

  //   const userData = isCompanyReg
  //     ? { ...userGeneralData, ...userCompanyData }
  //     : userGeneralData;

  //   // fetch options
  //   const options = {
  //     method: 'POST',
  //     headers: {
  //       'content-type': 'application/json',
  //     },
  //     credentials: 'include',
  //     body: JSON.stringify(userData),
  //   };

  //   try {
  //     const response = await fetch(`${routes.user.new}`, options);
  //     const json = await response.json();
  //     setIsPending(false);
  //     if (json.status === 'success') {
  //       await verifyViaSms(formData.phone);
            
  //       if (dadataValueExists && type==="company") {
  //         const companyData = parseCompanyDadata(selectedCompany); //
  //         if(companyData){
  //           const companyRes = await registerCompanyRequest({...companyData});
  //           options.companyId = companyRes.data.COMPANY_ID;
  //         }
  //       }

  //       await createNewPassword();
  //       if(props.setUser){
  //         props.setUser({ ...formData, subscribe, type });
  //       }
  //       if(props.onComplete){
  //         props.onComplete();
  //         props.onCheckSubscribe(subscribe);
  //       }
  //     }
  //     if (json.status === 'error') {
  //       setErrorMessages([json.errors[0].message]);
  //     }
  //   } catch (e) {
  //     setErrorMessages([messages.unknownError]);
  //     const errorText = `${e.name} : ${e.message}`;
  //       const title = document.getElementsByTagName('h1')[0]?.innerHTML || '';
  //       const currentLocation = window.location.pathname;
  //       const error = {
  //         errors: errorText,
  //         page: `Регистрация на сайте. Страница: ${title}. URL: ${currentLocation}`
  //       };
  //     openErrorMsgForm(error);
  //   }
  // };

  // const isValidInput = (inputObject, inputValue) => {
  //   if (inputObject.validator) return inputObject.validator(inputValue);
  //   if (inputObject.required && inputValue) return true;
  //   if (!inputObject.required) return true;
  //   return false;
  // };

  // const validateForm = () => {
  //   const newInputs = inputs.slice(0);
  //   const agreement = checkPolicyRef.current?.validateCheck();

  //   let isValidationPassed = true;
  //   newInputs.forEach((input, index) => {
  //     const isValid = isValidInput(input, formData[input.name]);

  //     isValidationPassed = isValidationPassed && isValid;
  //     if (!isValid !== input.error) {
  //       newInputs[index] = { ...input, error: !isValid };
  //     }
  //   });
  //   setInputs(newInputs);

  //   const errors = [];

  //   if(!isValidationPassed) errors.push(messages.formError);
  //   if(!agreement) errors.push(messages.checkArgeeWithPolicy);

  //   setErrorMessages(errors);

  //   return isValidationPassed && agreement;
  // };

  // const changeInput = (inputName, val, dadataValue = null) => {
  //   const newFormData = Object.assign({}, formData);
  //   newFormData[inputName] = val;
  //   if (inputName === 'company') setDadataValueExists(!!dadataValue);
  //   setFormData(newFormData);
  // };

  // const validateInput = name => {
  //   const currentInputIndex = inputs.findIndex(input => input.name === name);
  //   const currentInput = inputs[currentInputIndex];

  //   const isValid = isValidInput(currentInput, formData[currentInput.name]);

  //   if (!isValid !== currentInput.error) {
  //     const newInputs = inputs.slice(0);
  //     newInputs[currentInputIndex] = { ...currentInput, error: !isValid };
  //     setInputs(newInputs);
  //   }
  // };

  // const onSubmit = async () => {
  //   if (isPending) return;
    
  //   if (!validateForm()) {
  //     // eslint-disable-next-line no-console
  //     console.error('forms invalid');
  //     return;
  //   }
  //   setErrorMessages([]);

  //   await registerNewUser();
  // };

  return (
    // <div className={`registration ${props.className ? props.className : ''}`}>
    //   <h4 className="heading heading--2 heading--reverse">
    //     Регистрация на сайте
    //     <button
    //       type="button"
    //       className="btn btn--outline"
    //       onClick={loginViaPopup}
    //     >
    //       Войти в профиль
    //     </button>
    //   </h4>
    //   {props.allowChangeType ? (
    //     <ButtonTabs
    //       className='registration__tabs'
    //       options={[
    //         {
    //           label: 'Физ. лицо',
    //           value: false,
    //           checked: !isCompanyReg,
    //         },
    //         {
    //           label: 'Юр. лицо',
    //           value: true,
    //           checked: isCompanyReg,
    //         },
    //       ]}
    //       onChange={val => setIsCompanyReg(val)}
    //     />
    //   ) : (
    //     ''
    //   )}
    //   <div className="registration__form">
    //     <div className="inp-wrap">
    //       {inputs?.map(input =>
    //         prepareInput({
    //           ...input,
    //           value: formData[input.name],
    //           setSelectedCompany,
    //           onChangeCallback: changeInput,
    //           onBlurCallback: validateInput,
    //         }),
    //       )}
    //     </div>
    //   </div>
    //   <div className="separate" />
    //   {errorMessages.length >= 1 && (
    //     <React.Fragment>
    //       <FormMessage extraClass="error">
    //         {errorMessages.map(error => (
    //           <p className="form-message__p" key={error}>
    //             {error}
    //           </p>
    //         ))}
    //       </FormMessage>
    //     </React.Fragment>
    //   )}
    //   <CheckSubscribe checked={subscribe} onChange={setSubscribe} />
    //   <CheckPolicy ref={checkPolicyRef} />
    //   <div className="registration__btns">
    //     <Button isPending={isPending} onClick={onSubmit}>
    //       Продолжить
    //     </Button>
    //   </div>
    // </div>
    <h4 className="heading heading--2 heading--reverse">Регистрация на сайте временно недоступна</h4>
  );
};
